import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Paper } from '@mui/material';
// import SocialConnectBlock from 'src/components/settings/SocialConnectBlock';
import { ChangePasswordModal } from 'src/components/settings/ChangePasswordModal';
import TwoFactorAuth from 'src/components/settings/TwoFactorAuth';
import useStyles from './styles';
import { useStore } from 'src/stores';
export const SignInDetailsTab = observer(() => {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const getProfile = async () => {
    const resp = await store.account.getProfileAsync.run();
    return resp;
  };
  useEffect(() => {
    setIsLoading(true);
    getProfile().finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const connectedSocials = ['google', 'linkedin'];

  return /*#__PURE__*/React.createElement("div", {
    className: classes.tabWrapper
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.paperBody
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    gutterBottom: true
  }, t('general.change_password')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p",
    marginBottom: "18px"
  }, t('profile_settings.change_password_hint')), /*#__PURE__*/React.createElement(ChangePasswordModal, null))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Paper, null, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(TwoFactorAuth, null)) : /*#__PURE__*/React.createElement(TwoFactorAuth, null))));
});